t = require('app/scripts/views/internal/teacup-with-helpers')('sticker_select')

module.exports = t.renderable ({ additionalStickersEnabled, upsellEnabled, shouldShowUpgradePrompt }) ->
  t.div '.sticker-list.u-clearfix.js-standard-sticker-list'

  if !additionalStickersEnabled && shouldShowUpgradePrompt
    t.div '.sticker-upgrade-prompt-wrapper'

  if additionalStickersEnabled || upsellEnabled
    t.div '.js-premium-stickers'

    t.h2 '.js-custom-sticker-list-title.hide', ->
      t.format 'custom-stickers'

    t.div '.sticker-list.u-clearfix.js-custom-sticker-list'
